import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { PatientDocument } from '../../domain/models/patient-document.model';
import { IPatientDocumentsRepository } from '../../domain/repositories/patient-documents.repository';
import { PatientDocumentsRemoteDatasource } from '../datasources/remote/patient-documents.remote-datasource';
import { PatientDocumentMapper } from '../mappers/patient-document.mapper';

@Injectable()
export class PatientDocumentsRepositoryImpl implements IPatientDocumentsRepository {
  private readonly datasource = inject(PatientDocumentsRemoteDatasource);
  private readonly mapper = inject(PatientDocumentMapper);

  public list(organizationId: number, patientId: string): Observable<readonly PatientDocument[]> {
    return this.datasource.list(organizationId, patientId).pipe(
      map((dtos) => dtos.map((dto) => this.mapper.toPatientDocument(dto))),
    );
  }

  public upload(organizationId: number, patientId: string, file: File): Observable<PatientDocument> {
    return this.datasource.upload(organizationId, patientId, file).pipe(
      map((dto) => this.mapper.toPatientDocument(dto)),
    );
  }

  public download(organizationId: number, documentId: number): Observable<Blob> {
    return this.datasource.download(organizationId, documentId);
  }

  public remove(organizationId: number, documentId: number): Observable<void> {
    return this.datasource.remove(organizationId, documentId);
  }
}
